"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hasLength(input) {
    return input != null && input.length !== undefined;
}
exports.hasLength = hasLength;
//# sourceMappingURL=HasLength.js.map